import {Component, Input, OnInit} from '@angular/core';
import {EntryGroupService} from '@app/product/services/entry-group.service';
import {OrderConfirmationPageService} from '@app/services/order/order-confirmation-page.service';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {DcpEntryGroup} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {first} from 'rxjs/operators';
import {
  OrderConfirmationListItemComponentTexts,
  TransactionTypeTexts
} from '../../order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {OrderItemService} from '../../order-item/services/order-item.service';
import {CheckoutEntryValidationService} from '../../services/checkout-entry-validation.service';
import {DcpOrderTableComponent} from '../dcp-order-table/dcp-order-table.component';

@UntilDestroy()
@Component({
  selector: 'dcp-bundle-order-table',
  templateUrl: './dcp-bundle-order-table.component.html',
})
export class DcpBundleOrderTableComponent extends DcpOrderTableComponent implements OnInit {

  @Input() collapsable: boolean = false;
  @Input() collapsed: boolean = false;
  @Input() derivativeCount: number = 0;
  @Input() isInvalid: boolean;
  @Input() showPrice: boolean = false;
  @Input() showRemoveAction: boolean = false;
  @Input() showEditAction: boolean = false;
  @Input() componentTexts: OrderConfirmationListItemComponentTexts;
  transactionTypeTexts: TransactionTypeTexts;
  public isNetNewTransactionType: boolean;

  constructor(
    public entryValidationService: CheckoutEntryValidationService,
    protected entryGroupService: EntryGroupService,
    public orderItemService: OrderItemService,
    protected transactionTypeService: TransactionTypeService,
    private orderConfirmationPageService: OrderConfirmationPageService,
  ) {
    super(entryValidationService);
  }

  ngOnInit() {
    if (this.entry?.transactionType) {
      this.transactionTypeService.getTranslations(this.entry.transactionType)
        .pipe(first(), untilDestroyed(this))
        .subscribe(ttt => this.transactionTypeTexts = ttt);
    }
  }

  isFirstOrderEntryInContract(orderEntry: OrderEntry): boolean {
    const entryGroups: DcpEntryGroup[] = this.orderConfirmationPageService.getCartEntryGroups();
    return this.entryGroupService.getProductIndexInRootParentByProductCode(entryGroups, orderEntry?.product?.code) === 0;
  }
}
